export function connectSocket(url: string, shouldConnect: boolean) {
    if (!shouldConnect) return;
    const websocket = new WebSocket("__SITE_BASE__/api/v1/ws", 
        
    );
    
    websocket.onclose = () => {};
        
    return websocket;
}
